import { FC } from "react";
import CreatePage from "@lhd/components/CloneApp/pages/CreatePage";
import { APP_TYPES } from "@lhd/components/CloneApp/constants";
import { ROUTES } from "@lhd/constants";
import useCreate from "./hook";
import { Styles } from "./styled";

const CreateLayout = (props: ReturnType<typeof useCreate>) => {
  return (
    <Styles>
      <CreatePage
        appType={APP_TYPES.BUSINESS_TRIP_REPORTS}
        url={`/${ROUTES.BUSINESS_TRIP_REPORTS}`}
      />
    </Styles>
  );
};

const Create: FC = () => <CreateLayout {...useCreate()} />;

export default Create;
